import { Amenity, OfficeUtilityType, RoomType } from "@office-map/api-schema";

export const amenityTypes: Amenity[] = [
    "jabra",
    "projector",
    "whiteboard",
    "air-purifier",
    "tv-screen",
    "standing-desk",
];

// ?v=2 cache-busts previously cached URLs (images were previosly served with a 1-year immutable cache)
export const getAmenityIconPath = (amenity: Amenity): string => {
    return `/amenities/${amenity}.png?v=2`;
};

export const getAmenityLabel = (amenity: Amenity): string => {
    const mapping: Record<Amenity, string> = {
        jabra: "Jabra",
        projector: "Projector",
        whiteboard: "Whiteboard",
        "air-purifier": "Air Purifier",
        "tv-screen": "TV Screen",
        "standing-desk": "Standing Desk",
    };
    return mapping[amenity];
};

export const officeUtilityTypes: OfficeUtilityType[] = [
    "first-aid-kit",
    "microwave",
    "water-shutoff",
    "circuit-breaker",
    "fire-extinguisher",
    "fire-hydrant",
    "printer",
    "exit",
    "gas-shutoff",
    "water-boiler",
];

export const getUtilityLabel = (type: OfficeUtilityType): string => {
    const mapping: Record<OfficeUtilityType, string> = {
        "first-aid-kit": "First Aid Kit",
        microwave: "Microwave",
        "water-shutoff": "Water Shut-off Valve",
        "circuit-breaker": "Main Circuit Breaker",
        "fire-extinguisher": "Fire Extinguisher",
        "fire-hydrant": "Fire Hydrant",
        printer: "Printer",
        exit: "Exit",
        "gas-shutoff": "Main Gas Shut-off Valve",
        "water-boiler": "Water Boiler",
    };
    return mapping[type];
};

// ?v=2 cache-busts previously cached URLs (images were previosly served with a 1-year immutable cache)
export const getUtilityIconPath = (type: OfficeUtilityType): string => {
    return `/utilities/${type}.svg?v=2`;
};

export const roomTypes: RoomType[] = ["office", "meeting-room", "kitchen", "toilet", "other"];

export const getRoomTypeLabel = (type: RoomType): string => {
    const mapping: Record<RoomType, string> = {
        office: "Office",
        "meeting-room": "Meeting Room",
        kitchen: "Kitchen",
        toilet: "Toilet",
        other: "Other",
    };
    return mapping[type];
};
